import { abbrNumberFilter } from "app/filters/ngFilters";

export const formatEngagementNumber = (num: number): string => abbrNumberFilter()(num);
